// DB Method — Men's Protocol Landing Page JS

// Scroll-triggered fade animations
// Add .js-ready to body first, then apply fade animations
document.body.classList.add('js-ready');

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
    }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -20px 0px' });

// Nav scroll effect
const nav = document.querySelector('.nav');
window.addEventListener('scroll', () => {
  if (window.scrollY > 40) {
    nav.style.borderBottomColor = 'rgba(0,201,128,0.2)';
  } else {
    nav.style.borderBottomColor = 'rgba(0,201,128,0.1)';
  }
});

// Opt-in form handling
function handleSubmit(e) {
  e.preventDefault();
  const form = document.getElementById('optinForm');
  const success = document.getElementById('successMsg');
  form.style.display = 'none';
  success.style.display = 'block';
}

// Add fade-up class to relevant elements after DOM ready
window.addEventListener('DOMContentLoaded', () => {

  // Sticky CTA — price reveal + hide when Add to Cart is visible
  var shopSection = document.getElementById('optin');
  var addToCartBtn = document.getElementById('addToCartBtn');
  var stickyEl = document.getElementById('mobileSticky');
  var ctaText = document.getElementById('stickyCTAText');
  if (shopSection && ctaText && stickyEl) {
    var shopPassed = false;
    window.addEventListener('scroll', function() {
      // Reveal price once shop section reaches 75% of viewport
      if (!shopPassed) {
        var rect = shopSection.getBoundingClientRect();
        if (rect.top <= window.innerHeight * 0.75) {
          shopPassed = true;
          ctaText.textContent = 'Start the Protocol — $199';
        }
      }
      // Hide sticky when Add to Cart button is on screen
      if (addToCartBtn) {
        var btnRect = addToCartBtn.getBoundingClientRect();
        var btnVisible = btnRect.top < window.innerHeight && btnRect.bottom > 0;
        stickyEl.style.opacity = btnVisible ? '0' : '';
        stickyEl.style.pointerEvents = btnVisible ? 'none' : '';
      }
    }, { passive: true });
  }

  // Original DOMContentLoaded block continues below...
  const selectors = [
    '.protocol-card',
    '.testimonial',
    '.science-stat-card',
    '.strip-item'
  ];
  selectors.forEach(sel => {
    document.querySelectorAll(sel).forEach((el, i) => {
      el.classList.add('fade-up');
      el.style.transitionDelay = (i * 80) + 'ms';
    });
  });
  // Observe after adding classes
  document.querySelectorAll('.fade-up').forEach(el => observer.observe(el));
});

/* ── Shop Carousel ─────────────────────────────────── */
(function () {
  var current = 0;
  var total = 5;
  var track = document.getElementById('shopCarouselTrack');
  var dots = document.querySelectorAll('.shop__dot');

  // Touch / swipe support
  var touchStartX = 0;
  var carousel = document.getElementById('shopCarousel');

  function goTo(index) {
    current = (index + total) % total;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dots.forEach(function (d, i) {
      d.classList.toggle('shop__dot--active', i === current);
    });
  }

  // Expose to inline onclick handlers
  window.shopCarouselStep = function (dir) { goTo(current + dir); };
  window.shopCarouselGoTo = function (index) { goTo(index); };

  // Swipe
  if (carousel) {
    carousel.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    carousel.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) goTo(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  // Keyboard when focused
  document.addEventListener('keydown', function (e) {
    if (!carousel) return;
    var rect = carousel.getBoundingClientRect();
    var inView = rect.top < window.innerHeight && rect.bottom > 0;
    if (!inView) return;
    if (e.key === 'ArrowRight') goTo(current + 1);
    if (e.key === 'ArrowLeft') goTo(current - 1);
  });
})();

/* ── Side Cart — Shopify AJAX Cart API ─────────────── */
(function () {
  var VARIANT_ID = 17007722561606; // DB Method Machine — Default Title
  var cart = document.getElementById('sideCart');
  var overlay = document.getElementById('cartOverlay');
  var count = document.getElementById('cartCount');
  var addBtn = document.getElementById('addToCartBtn');
  var cartToggle = document.getElementById('cartToggle');

  function renderCart(cartData) {
    var body = cart.querySelector('.side-cart__body');
    var footer = cart.querySelector('.side-cart__footer');
    var hasItem = cartData.item_count > 0;
    if (body) body.style.display = hasItem ? '' : 'none';
    if (footer) footer.style.display = hasItem ? '' : 'none';
    var empty = cart.querySelector('.side-cart__empty');
    if (!empty) {
      empty = document.createElement('div');
      empty.className = 'side-cart__empty';
      empty.innerHTML = '<p>Your cart is empty.</p>';
      cart.insertBefore(empty, footer || null);
    }
    empty.style.display = hasItem ? 'none' : 'block';
  }

  function openCart() {
    fetch('/cart.js').then(function(r){return r.json();}).then(function(d){
      updateCartCount(d.item_count);
      renderCart(d);
    });
    cart.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cart.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function setButtonAdded() {
    if (addBtn) {
      addBtn.textContent = 'Added to Cart ✓';
      addBtn.style.background = 'rgba(0,201,128,0.15)';
      addBtn.style.color = 'var(--green)';
      addBtn.style.border = '1px solid var(--green)';
    }
  }

  function setButtonDefault() {
    if (addBtn) {
      addBtn.textContent = 'Add to Cart';
      addBtn.style.background = '';
      addBtn.style.color = '';
      addBtn.style.border = '';
    }
  }

  function updateCartCount(n) {
    if (n > 0) {
      count.style.display = 'flex';
      count.textContent = n;
    } else {
      count.style.display = 'none';
    }
  }

  function addToCart() {
    if (addBtn) { addBtn.textContent = 'Adding...'; addBtn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: VARIANT_ID, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      setButtonAdded();
      if (addBtn) addBtn.disabled = false;
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cartData) {
      updateCartCount(cartData.item_count);
      openCart();
    })
    .catch(function (err) {
      console.error('Cart add error:', err);
      if (addBtn) { addBtn.textContent = 'Add to Cart'; addBtn.disabled = false; }
    });
  }

  function removeFromCart() {
    var updates = {};
    updates[VARIANT_ID] = 0;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(function (r) { return r.json(); })
    .then(function (cartData) {
      updateCartCount(cartData.item_count);
      renderCart(cartData);
      setButtonDefault();
    })
    .catch(function () { closeCart(); });
  }

  // Checkout button in side cart
  var checkoutBtn = document.getElementById('cartCheckoutBtn');
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      window.location.href = '/checkout';
    });
  }

  // Nav cart toggle — sync count on open
  if (cartToggle) {
    cartToggle.addEventListener('click', function () {
      if (cart.classList.contains('is-open')) {
        closeCart();
      } else {
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (d) {
          updateCartCount(d.item_count);
        });
        openCart();
      }
    });
  }

  // Sync count on page load
  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (d) {
    updateCartCount(d.item_count);
  });

  window.openCart = openCart;
  window.closeCart = closeCart;
  window.addToCart = addToCart;
  window.removeFromCart = removeFromCart;

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });
})();

/* ── Science Strip Slider (mobile) ───────────────────────────── */
(function () {
  var track = document.getElementById('stripSliderTrack');
  var dots = document.querySelectorAll('.strip-slider__dot');
  var current = 0;
  var total = 3;
  var touchStartX = 0;
  var slider = document.getElementById('stripSlider');

  function stripGoTo(index) {
    current = (index + total) % total;
    track.style.transform = 'translateX(-' + (current * 100) + '%)';
    dots.forEach(function (d, i) {
      d.classList.toggle('strip-slider__dot--active', i === current);
    });
  }
  window.stripGoTo = stripGoTo;

  if (slider) {
    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    slider.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) stripGoTo(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }
})();

/* ── Mobile Nav Drawer ──────────────────────────────── */
(function () {
  var hamburger = document.getElementById('navHamburger');
  var drawer = document.getElementById('mobileNavDrawer');
  var overlay = document.getElementById('mobileNavOverlay');
  var closeBtn = document.getElementById('mobileNavClose');

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    hamburger.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    hamburger.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (hamburger) hamburger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // Close on any nav link tap
  if (drawer) {
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeDrawer);
    });
  }

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();

/* ── Mobile Sticky CTA ──────────────────────────────── */
(function () {
  var sticky = document.getElementById('mobileSticky');
  var hero = document.getElementById('hero');
  if (!sticky || !hero) return;

  function onScroll() {
    var heroBottom = hero.getBoundingClientRect().bottom;
    if (heroBottom < 0) {
      sticky.classList.add('is-visible');
    } else {
      sticky.classList.remove('is-visible');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run on load
})();
